var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333374 6.99952C0.333374 3.32019 3.32004 0.332855 7.00004 0.332855C10.6867 0.332855 13.6667 3.32019 13.6667 6.99952C13.6667 10.6802 10.6867 13.6662 7.00004 13.6662C3.32004 13.6662 0.333374 10.6802 0.333374 6.99952ZM6.41337 4.47286C6.41337 4.15352 6.68004 3.88619 7.00004 3.88619C7.32004 3.88619 7.58004 4.15352 7.58004 4.47286V7.41952C7.58004 7.74019 7.32004 7.99952 7.00004 7.99952C6.68004 7.99952 6.41337 7.74019 6.41337 7.41952V4.47286ZM7.00671 10.1202C6.68004 10.1202 6.42004 9.85352 6.42004 9.53352C6.42004 9.21352 6.68004 8.95352 7.00004 8.95352C7.32671 8.95352 7.58671 9.21352 7.58671 9.53352C7.58671 9.85352 7.32671 10.1202 7.00671 10.1202Z",
    fill: "#DDDDDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoGray);
export default __webpack_public_path__ + "static/media/info_gray.a8a63a31.svg";
export { ForwardRef as ReactComponent };